import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const newsEventsCarousels = document.querySelectorAll(
    '.block-news .block-news__carousel'
  );

  if (0 < newsEventsCarousels.length) {
    newsEventsCarousels.forEach((newsEventsCarousel) => {
      new Swiper(newsEventsCarousel, {
        slidesPerView: 1.15,
        spaceBetween: 20,
        pagination: {
          el: '.block-news .vtx-swiper__pagination',
          type: 'fraction',
        },
        navigation: {
          nextEl: '.block-news .swiper-button-next.vtx-swiper__next',
          prevEl: '.block-news .swiper-button-prev.vtx-swiper__prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 2.25,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      });
    });
  }
});
